export const PLATFORM_FEATURES = {
  TRACING_AI: 'tracing-ai',
  AUDIT_AI: 'audit-ai',
  CAPA: 'capa',
  CAPA_BASIC: 'capa:basic',
  CAPA_ADVANCED: 'capa:advanced',
  CAPA_V2: 'capa-v2',
  CASCADE_TRACING: 'cascade-tracing',
  CERTIFIED_MATERIALS_MANAGEMENT: 'certified-materials-management',
  COMPANY_PROFILES: 'company-profiles',
  ENTITY_SCREENING_V2: 'entity-screening-v2',
  ITC_INTEGRATION: 'itc-integration',
  KHARON_ENTITY_LIST: 'kharon-entity-list',
  KHARON_V2: 'kharon-v2',
  NEW_STYLE_STRUCTURE: 'new-style-structure',
  PRODUCT_MAPPING: 'product-mapping',
  SLCP_ASSESSMENT: 'slcp-assessment',
  SUPPLY_CHAIN_MAPPING_PRODUCT_STORY: 'supply-chain-mapping-product-story',
  VIEW_NETWORK_USERS_INFO: 'view-network-users-info',
  DROP_BOX: 'drop_box',
  SUPPLIER_QUESTIONNAIRE: 'supplier_questionnaire',
  ORDERS_HUB: 'order-hub',
} as const;
